<div class="row ">
    <div class="col-md-6">
      <div> <input type="search" (ngModelChange)="applyFilter($event)" [(ngModel)]="searchText" class="form-control mb-2 " placeholder="Search by vehicleID" style="width: 50%"> </div>
    </div>
   
   
    <div class="col-md-6 m-0 text-end">
      <button (click)="exportToExcel()" style="margin-right:5px !important" class="btn-shadow  d-inline-flex align-items-center btn btn-success"><i class="fa fa-file-excel-o" aria-hidden="true"></i>
         Export Current Excel  </button>
         <button  class="btn-shadow d-inline-flex align-items-center btn btn-success"><i class="fa fa-file-excel-o" aria-hidden="true"></i>
          Export All Excel </button>
    </div>
  </div>

  <div class="main-card mb-3 card">
    <div class="card-header font-weight-B fs-1r ">
      All Vehicle Bookings
    </div>
    <div class="table-responsive">
      <table class="align-middle mb-0 table table-borderless table-striped table-hover" id="excel-table">
        <thead>
        <tr>
          <!-- <th class="text-left" >#</th> -->
          <th>Vehicle ID</th>
          <th class="w-15">Package ID</th>
          <th>Booking Status</th>
          <th>Status</th>
          <th>Booking Date</th>
          <th>Booking Time</th>
          <th class="text-end">Actions</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let data of allVehicleBookingList | paginate : { itemsPerPage: itemsPerPage, currentPage: page, totalItems: totalItems  }">
          <!-- <td class="text-left text-muted">#345</td> -->
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading"> {{data.vehicleId}}          </div>
                  <!-- <div class="widget-subheading opacity-7">Web Developer</div> -->
                </div>
              </div>
            </div>
          </td>
          <td class="w-15">
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">{{data.packageId}}</div>
                  <!-- <div class="widget-subheading opacity-7">Web Developer</div> -->
                </div>
              </div>
            </div>
          </td>

          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">
                    <span *ngIf="data.bookingStatus == 1"> Done </span>
                    <span *ngIf="data.bookingStatus == 0"> Pending </span>
                </div>
                  <!-- <div class="widget-subheading opacity-7">Web Developer</div> -->
                </div>
              </div>
            </div>
          </td>
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">
                    <span *ngIf="data.status == 1"> Done </span>
                    <span *ngIf="data.status == 0"> Pending </span>
                  </div>
                  <!-- <div class="widget-subheading opacity-7">Web Developer</div> -->
                </div>
              </div>
            </div>
          </td>
          
            <td>
              <div class="widget-content p-0">
                <div class="widget-content-wrapper">
                  <div class="widget-content-left flex2">
                    <div class="widget-heading">{{data.bookingDate}}</div>
                    <!-- <div class="widget-subheading opacity-7">Web Developer</div> -->
                  </div>
                </div>
              </div>
            </td>
            <td>
                <div class="widget-content p-0">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left flex2">
                      <div class="widget-heading">{{data.bookingTime}}</div>
                      <!-- <div class="widget-subheading opacity-7">Web Developer</div> -->
                    </div>
                  </div>
                </div>
              </td>
         
          <td class="text-end">
            <div class="dropdown">
              <button class="btn btn-info dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                Action
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li><a class="dropdown-item" (click)="editVehicleBooking(data , editBooking)"  >Edit <i class="fa fa-pencil"></i></a></li>
                <li><a class="dropdown-item" (click)="deleteVehicleBooking(data)" >Delete <i class="fa fa-trash"></i></a></li>
              </ul>
            </div>
          </td>

        </tr>
       
        </tbody>
        <div *ngIf="allVehicleBookingList?.length  == 0" class="text-center mt-5 mb-5" >
          <span class="text-danger">Data Not found</span>
        </div>
        
      </table>
      <!-- <pagination-controls class="my-pagination" (pageChange)="gty((page = $event))"></pagination-controls> -->
      <ngb-pagination
      (pageChange)="gty((page = $event))"
      [collectionSize]="totalItems"
      [(page)]="page"
      [pageSize]="itemsPerPage"
      [maxSize]="3"
      [rotate]="true"
      [boundaryLinks]="false"
    >
    </ngb-pagination>
    </div>
  </div>



  <div class="card-body">
    <ng-template #editBooking let-c="close" let-d="dismiss">
      <div class="modal-header">
        <h4 class="modal-title"> <i class="fa fa-pencil" aria-hidden="true"></i> Edit Vehicle Booking   </h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')">
        </button>
      </div>
      <div class="modal-body">

        <div class="row ">
            <div class="col-md-2"></div>
            <div class="col-md-8 form-group">
                <label for="">Vehicle ID</label>
                <input type="text" [(ngModel)]="vehicleID" [disabled]="true" class="form-control"> 
                <label for="">Package ID</label>
                <input type="text" [(ngModel)]="packageID" [disabled]="true" class="form-control">
                <label for="">Booking Status</label>
                <select [(ngModel)]="bookingStatus" class="form-control">
                    <option value="1"> Done </option>
                    <option value="0"> Pending </option>
                </select>
                <label for=""> Status</label>
                <select [(ngModel)]="status" class="form-control">
                    <option value="1"> Done </option>
                    <option value="0"> Pending </option>
                </select>
            </div>
            <div class="col-md-2"></div>
        </div>



         <div class="row mt-2 mb-2 text-center">
           <div class="col-md-12">
             <button (click)="updateVehcleBooking()"  class="btn btn-primary btn-lg btn-block">Update Vehicle Booking </button>
           </div>
         </div>  
  
      </div>
      <!-- <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="c('Close click')">Close</button>
        <button type="button" class="btn btn-primary">Save changes</button>
      </div> -->
    </ng-template>
    <!-- <button class="btn btn-primary" (click)="open(content5)">Launch demo modal</button> -->
  </div>